import React from 'react';
import MusicEditDeletePopup from './MusicEditDeletePopup';
import MusicEditTitlePopup from './MusicEditTitlePopup';
import MusicEditDisabledPopup from './MusicEditDisabledPopup';
import { MusicClientContext } from '../../context/MusicClientContext';
import { MusicEntity } from '../../types/MusicEntityTypes';

export default function MusicEditPopupSequence({
  music,
  onClose,
  onEdit,
  onDelete,
} : {
  music: MusicEntity,
  onClose: () => void,
  onEdit: () => void,
  onDelete: () => void,

}) {
  const [popup, setPopup] = React.useState<'init'|'edit'|'disabled'|'delete'>('init');

  const { getMusicIsEditable } = React.useContext(MusicClientContext);

  React.useEffect(() => {
    if (popup === 'init') {
      getMusicIsEditable(music.id).then((data) => {
        if (data.editable) {
          setPopup('edit');
        } else {
          // ダウンロード許可が出ている曲の編集はできない
          setPopup('disabled');
        }
      });
    }
  }, [popup]);

  return (
    <>
      {popup === 'edit' && (
        <MusicEditTitlePopup
          music={music}
          onDone={() => onEdit()}
          onClose={() => onClose()}
          onDelete={() => setPopup('delete')}
        />
      )}
      {popup === 'delete' && (
        <MusicEditDeletePopup
          music={music}
          onDone={() => onDelete()}
          onCancel={() => onClose()}
        />
      )}
      {popup === 'disabled' && (
        <MusicEditDisabledPopup
          onClose={() => onClose()}
        />
      )}
    </>
  );
}
